import React, { useState } from 'react'

import styles from '../../Products.module.scss'

import { SettingsAdjust as SettingsIcon } from '../../../../icons'
import CustomRadio from 'components/elements/inputs/CustomRadio'
import CustomInput from 'components/elements/inputs/CustomInput'
import UnblockerUsageResult from '../UnblockerUsageResult'

const usageTypes = [
  {
    label: 'Get usage statistics by calls',
    value: 'by_calls',
  },
  {
    label: 'Check concurrency',
    value: 'concurrency',
  },
  {
    label: 'Get daily usage statistics, days',
    value: 'daily',
  },
]

const UnblockerUsage: React.FC = () => {
  const [selectedUsageType, setSelectedUsageType] = useState(
    usageTypes[0].value
  )
  const [daysValue, setDaysValue] = useState('7')

  const handleUsageTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedUsageType(e.target.value)
  }

  const handleDaysChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDaysValue(e.target.value)
  }

  return (
    <div className={styles.container}>
      <div
        className={`
          ${styles.contentBlock}
          ${styles.leftSide}
        `}
      >
        <div className={styles.blockHeader}>
          <div className={styles.headerIconWrapper}>
            <SettingsIcon />
          </div>
          <span className={styles.blockTitle}>API usage</span>
        </div>

        <div className={styles.form}>
          <div className={styles.usageTypeItem}>
            <CustomRadio
              id={`usage_type_radio-by_calls`}
              name={'usage-type'}
              value={'by_calls'}
              checked={selectedUsageType === 'by_calls'}
              onChange={handleUsageTypeChange}
              // className={styles.radio}
            >
              Get usage statistics by calls
            </CustomRadio>
          </div>
          <div className={styles.usageTypeItem}>
            <CustomRadio
              id={`usage_type_radio-concurrency`}
              name={'usage-type'}
              value={'concurrency'}
              checked={selectedUsageType === 'concurrency'}
              onChange={handleUsageTypeChange}
              // className={styles.radio}
            >
              Check concurrency
            </CustomRadio>
          </div>
          <div className={styles.usageTypeItem}>
            <CustomRadio
              id={`usage_type_radio-daily`}
              name={'usage-type'}
              value={'daily'}
              checked={selectedUsageType === 'daily'}
              onChange={handleUsageTypeChange}
              // className={styles.radio}
            >
              Get daily usage statistics, days
            </CustomRadio>

            <CustomInput
              className={styles.daysInput}
              type={'number'}
              value={daysValue}
              onChange={handleDaysChange}
            />
          </div>
        </div>
      </div>
      <div
        className={`
          ${styles.contentBlock}
          ${styles.rightSide}
        `}
      >
        <UnblockerUsageResult
          selectedUsageType={selectedUsageType}
          daysValue={daysValue}
        />
      </div>
    </div>
  )
}

export default UnblockerUsage
